import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import Logo from '../Logo/Logo';

const Hero = ({ data }) => {
  const {
    location, business_name: businessName, logo_url: logoUrl, occupation_name: occupation
  } = data;
  return (
    <>
      <header className={styles.hero}>
        {logoUrl && <Logo url={logoUrl} />}
        <h1>{businessName}</h1>
        <p>{`${occupation} - ${location}`}</p>
      </header>
    </>
  );
};

Hero.propTypes = {
  data: PropTypes.shape({
    logo_url: PropTypes.string,
    business_name: PropTypes.string,
    location: PropTypes.string,
    occupation_name: PropTypes.string,
  })
};

export default Hero;
